// constants
import { DATE_FORMAT_OPTIONS, DATE_FORMAT_VALUES } from 'constants/index'
// types
import { FieldType, IField, IRiskTemplate } from 'types/graphql'
// utils
import { getOptionByValue } from 'utils/form'
import { getDefaultDateFormat } from 'utils/date'

interface IFieldMapping {
  riskTemplateId: string
  fieldIds: string[]
}

export const getSettingsByType = (property: IField, riskTemplates: IRiskTemplate[]) => {
  const settings = property.settings || {}

  switch (property.fieldType) {
    case FieldType.Date:
      return {
        ...settings,
        format: getOptionByValue(property.settings?.format || DATE_FORMAT_VALUES.DATE, DATE_FORMAT_OPTIONS),
        dateFormat: property.settings?.dateFormat || getDefaultDateFormat(property.settings?.format)
      }

    case FieldType.RiskMatrix:
      return {
        ...settings,
        appetiteEnabled: !!property.settings?.appetiteEnabled
      }

    case FieldType.Text:
    case FieldType.Number:
      return {
        ...settings,
        manualSave: !!property.settings?.manualSave
      }

    case FieldType.RecordLinks:
    case FieldType.ParentRelatedForms: {
      const fieldMappings = ((settings.fieldMappings as IFieldMapping[]) || []).map((mapping) => {
        const template = riskTemplates.find((t) => t.id === mapping.riskTemplateId)

        return {
          templateId: { label: template?.name, value: mapping.riskTemplateId },
          fieldIds: (mapping.fieldIds ?? []).map((fieldId) => {
            const field = template?.fields.find((f) => f.id === fieldId)

            return { label: field?.label, value: fieldId }
          })
        }
      })
      return { ...settings, fieldMappings }
    }

    default:
      return settings
  }
}
